import {
  initialWorkflowConversationState,
  workflowChatReducer,
} from "@intelligems/ig-plugin/builder";
import { ConversationAction, ConversationState } from "@intelligems/ig-types";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

const workflowsSlice = createSlice({
  name: "workflow",
  initialState: initialWorkflowConversationState,
  reducers: {
    clearWorkflow: (_draft: any) => {
      const draft = _draft as ConversationState;
      Object.assign(draft, initialWorkflowConversationState);
    },
    handleAction: (_draft: any, action: PayloadAction<ConversationAction>) => {
      const draft = _draft as ConversationState;
      const payload = action.payload;

      return workflowChatReducer(draft, payload);
    },
  },
  selectors: {
    getWorkflow: (state) => state,
    getNodeExecutionStatus: (state) => state.nodeExecutionStatus,
  },
});

export const { handleAction, clearWorkflow } = workflowsSlice.actions;

export const workflowsReducer = workflowsSlice.reducer;
export const { getWorkflow, getNodeExecutionStatus } = workflowsSlice.selectors;
